import { render } from "./displaymoduleledord.vue?vue&type=template&id=47106462"
import script from "./displaymoduleledord.vue?vue&type=script&lang=js"
export * from "./displaymoduleledord.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__